<template>
    <div class="training-step1">
        <div class="training-step1-flex">
            <div class="training-step1-left">
                <el-form :model="formData" :rules="formData.status !== 7 ? rules : {}" ref="traningStep1From" label-width="200px" key="2" class="training-step-form">
                    <el-form-item label="培训班名称：" prop="trainName" class="long-item">
                        <el-input v-model="formData.trainName" placeholder="请输入培训班名称" :disabled="formData.status !== 7 ? false : true"></el-input>
                    </el-form-item>
                    <el-form-item label="班主任：" prop="trainTeachers" class="long-item">
                        <el-select v-model="formData.trainTeachersId"  multiple placeholder="请选择班主任" :disabled="formData.status !== 7 ? false : true" @change="trainTeacherChange">
                            <el-option 
                                v-for="(item, index) in userList"
                                :key="index"
                                :label="item.realname"
                                :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="实施部门：" prop="trainOrgId" class="spec-item-content">
                        <el-cascader
                        :options="orgList"
                        placeholder="请选择实施部门"
                        :props="{ checkStrictly: true, label: 'name', value: 'id', children: 'orgs' }"
                        v-model="formData.trainOrgId"
                         :disabled="formData.status !== 7 ? false : true"
                        clearable></el-cascader>
                    </el-form-item>
                    <el-form-item label="开始时间：" prop="startTime">
                        <el-date-picker
                            v-model="formData.startTime"
                            type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :picker-options="{disabledDate: disabledStartDate}"
                            @change="startChange"
                             :disabled="true"
                            placeholder="请选择开始时间">
                            </el-date-picker>
                    </el-form-item>
                    <el-form-item label="结束时间：" prop="endTime" class="spec-item-label">
                        <el-date-picker
                            v-model="formData.endTime"
                            type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :picker-options="{disabledDate: disabledEndDate}"
                             :disabled="true"
                            placeholder="请选择结束时间">
                            </el-date-picker>
                    </el-form-item>
                    <el-form-item label="计划人数：" prop="stuNum" class="spec-item-content">
                        <el-input v-model="formData.stuNum" :disabled="formData.status !== 7 ? false : true"></el-input>
                    </el-form-item>
                    <el-form-item label="报名是否受培训班人数控制：" prop="isControl" class="spec-item-content">
                        <el-radio-group v-model="formData.isControl" :disabled="formData.status !== 7 ? false : true">
                            <el-radio :label="1">是</el-radio>
                            <el-radio :label="0">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="课时：" prop="period">
                        <el-input type="number" v-model="formData.period" :disabled="formData.status !== 7 ? false : true"></el-input>
                    </el-form-item>
                    <el-form-item label="学分：" prop="credits" class="spec-item-label">
                        <el-input type="number" v-model="formData.credit" :disabled="formData.status !== 7 ? false : true"></el-input>
                    </el-form-item>
                    <el-form-item label="证书配置：" prop="certificateId" class="long-item">
                        <el-select v-model="formData.certificateId" placeholder="请选择" :disabled="formData.status !== 7 ? false : true">
                            <el-option 
                                v-for="(item, index) in certificateList"
                                :key="index"
                                :label="item.certificateName"
                                :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="培训目标：" prop="target" class="long-item">
                        <el-input v-model="formData.target" :disabled="formData.status !== 7 ? false : true"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div class="training-step-upload" v-if="!formData.cover">
                <div class="training-step-upload-title">上传封面图片</div>
                <div class="training-step-upload-desc">图片尺寸 335*200，支持格式 .png .jpg .jpeg</div>
                <oosUpload
                    ref="oosRefUpload"
                    fileType="image"
                    :value.sync="fileList"
                    :showFileList="false"
                    @on-sucess="onUploadSucess"
                    class="user-setting-img"
                    :limit="1"
                    :uploadIcon="require('@/assets/images/icon_photo_camera@2x.png')"
                    ></oosUpload>
            </div>
            <div v-if="formData.cover" class="training-step-upload-finish">
                <el-image class="cover-img" :src="formData.cover | imgFilter" fit="cover"></el-image>
            </div>
        </div>
        <div class="training-step-btns" v-if="formData.status !== 7">
            <el-button type="primary" size="mini" @click="saveStep">保存</el-button>
        </div>
    </div>
</template>
<script>
import oosUpload from '@/components/oosUpload/index.vue'

export default {
    name: 'TrainingStep1',
    props: ['formData', 'userList', 'trainTeachersId'],
    components: { oosUpload },
    data() {
        return {
            rules: {
                trainName: [
                    { required: true, message: '请输入培训班名称', trigger: 'change' },
                ],
                trainTeachers: [
                    { required: true, message: '请选择班主任', trigger: 'change' },
                ],
                trainOrgId: [
                    { required: true, message: '请选择实施部门', trigger: 'change' },
                ],
                startTime: [
                    { required: true, message: '请选择开始时间', trigger: 'change' },
                ],
                endTime: [
                    { required: true, message: '请选择结束时间', trigger: 'change' },
                ],
                period: [
                    { pattern: /\d/, message: '请输入数字', trigger: 'change' }
                ],
                stuNum: [
                    { pattern: /\d/, message: '请输入数字', trigger: 'change' }
                ],
                credits: [
                    { pattern: /\d/, message: '请输入数字', trigger: 'change' }
                ]
            },
            fileList: [],
            orgList: [],
            certificateList: []
        }
    },
    mounted() {
        this.getOrgTreeList()
        this.getCertificateList()
        this.$nextTick(() => {
            if (this.$refs.traningStep1From) {
                this.$refs.traningStep1From.resetFields()
            }
        })
    },
    methods: {
        trainTeacherChange(val) {
            this.formData.trainTeachersId = val
            this.$forceUpdate()
        },
        onUploadSucess(file, fileList) {
            this.formData.cover = fileList[0].url
        },
        disabledEndDate(time) {
            const start = new Date(this.formData.create_time)
            return time.getTime() < start.getTime()
        },
        disabledStartDate(time) {
            const start = new Date()
            return time.getTime() < start.getTime() - 24*60*60*1000
        },
        startChange() {
            this.formData.expect_time = ''
        },
        // 实施部门
        getOrgTreeList() {
            this.$api.user.baseInfo.orgTreeList({name: '', orgManage: 1}).then(res => {
                this.orgList = res.data
            })
        },
        // 证书
        getCertificateList() {
            this.$api.user.baseInfo.certificateList({formData: {teacher: 1}, pageData: {currentPage: 1, pageSize: 99999}}).then(res => {
                this.certificateList = res.data.list
            })
        },
        saveStep() {
            this.$emit('saveStep')
        }
    }
}
</script>
<style lang="scss" scoped>
@import '../../../styles/variables.scss';

.training-step1 {
    background: $white_bg_color;
    .training-step1-flex {
        display: flex;
        padding: .26rem .35rem .9rem .1rem;
    }
    .training-step1-left {
        width: 8.16rem;
        margin-right: .15rem;
    }
    .training-step-upload {
        width: 3.35rem;
        height: 2rem;
        padding: .2rem;
        border: 1px solid $grey_border_color_ddd;
        .training-step-upload-title {
            margin-bottom: .06rem;
            font-size: .14rem;
            color: $font_color_77E;
        }
        .training-step-upload-desc {
            margin-bottom: .3rem;
            font-size: .12rem;
            color: $font_color_A6;
        }
        .wt-oss-upload .post-upload-btn {
            width: .6rem;
        }
        
    }
    .training-step-upload-finish {
        width: 3.35rem;
        height: 2rem;
        border: 1px solid $grey_border_color_ddd;
        .cover-img {
            width: 100%;
            height: 100%;
        }
    }
    .training-step-btns {
        height: .83rem;
        padding: .24rem 0 .3rem;
        border-top: 1px solid $grey_border_color_e6;
        text-align: center;
        .el-button {
            vertical-align: top;
            width: .9rem;
        }
    }
}
</style>

<style lang="scss">
@import '../../../styles/variables.scss';
@import '../../../styles/mixin.scss';

.training-step1 {
    .training-step-upload {
        .wt-oss-upload .post-upload-btn {
            width: .6rem;
            height: auto;
            vertical-align: top;
        }
        .wt-oss-upload {
            height: .54rem;
            text-align: center;
            .upload-wrap, .el-upload {
                height: 100%;
            }
        }
    }
}

.training-step-form {
    @include clear-float();
    .el-input.is-disabled .el-input__inner {
        background-color: transparent;
        border-color: transparent;
        color: #333333;
    }
    .el-input.is-disabled .el-input__icon {
        display: none;
    }
    .el-input.is-disabled.el-input--suffix .el-input__inner {
        padding-left: .15rem;
    }
    .el-form-item {
        float: left;
        margin-bottom: .16rem;
        .el-input__inner {
            width: 2.4rem;
        }
    }
    .long-item {
        .el-input__inner {
            width: 6.1rem;
        }
    }
    .spec-item-content {
        .el-form-item__content {
            width: 6.1rem;
        }
    }
    .spec-item-label {
        .el-form-item__label {
            width: 130px!important;
            &+.el-form-item__content {
                margin-left: 130px!important;
            }
        }
    }
    .training-step-border {
        width: 6.1rem;
        min-height: .4rem;
        padding: .06rem .08rem;
        border-radius: .04rem;
        border: 1px solid $grey_border_color_ddd;
    }
}
</style>